import { createContext, useContext } from 'react';

/** Which side panel replaces the inspector, if any. */
export type PanelKind = 'settings' | 'layers' | 'share' | 'export' | 'shortcuts' | 'about' | 'storage' | 'boards' | 'sheet' | null;

export const PanelContext = createContext<{ panel: PanelKind; setPanel: (p: PanelKind) => void }>({
  panel: null,
  setPanel: () => {},
});

export const usePanel = () => useContext(PanelContext);
